import React from 'react';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from './Dialog/Dialog';
import RangeDatePicker from '../fields/RangeDatePicker/RangeDatePicker';
import { Button, Icons } from './BootstrapComponents/BootstrapComponents';
import FieldDTO from '../fields/Abstract/FieldDTO';
import { createClearObject } from '../../utils/utils';
import CalendarDatePicker from '../fields/RangeDatePicker/CalendarDatePicker';

export default function MobileSearchModal(props) {
  const {
    control,
    defaultValues,
    reset = () => {},
    handleClose = () => {},
    getValues = () => {},
  } = props;

  const clear = () => {
    const fields = getValues();
    const cleared = createClearObject(fields);
    reset({ ...cleared, ...defaultValues });
  };

  return (
    <Dialog
      className="mobile-search-modal mobile-period-modal"
      onClose={() => { handleClose(); }}
      size="xl"
      open
    >
      <DialogContent className="msm-content">
        <div className="msm-header">
          <div className="title-text">Период</div>
          <div className="close-wrapper">
            <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={handleClose} />
          </div>
        </div>
        <div className="period-wrapper">
          <FieldDTO
            control={control}
            component={CalendarDatePicker}
            dtoObject={{
              name: 'created_at',
              type: String,
              validators: {},
              labelKey: 'application.created_at',
            }}
            usePortal
            placeholder="Дата подачи"
            changeFormat="YYYY-MM-DD"
            className="no-border"
          />
        </div>
      </DialogContent>
      <DialogFooter className="msm-footer">
        <Button variant="secondary" onClick={clear}>Сбросить</Button>
        <Button onClick={handleClose}>Найти</Button>
      </DialogFooter>
    </Dialog>
  );
}
